// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1FkIT","info":"Note_info__1_d7s","note":"Note_note__FJ7n1","actions":"Note_actions__-jj2G"};